import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-245fc74c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal is-active"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "notification is-warning" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = {
  key: 0,
  class: "block"
}
const _hoisted_7 = { class: "block" }
const _hoisted_8 = { class: "block" }
const _hoisted_9 = { class: "buttons" }
const _hoisted_10 = ["title", "disabled"]
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_ctx.error)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.t("sthwentwrong")), 1),
            (_ctx.canUndo)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                  _createTextVNode(_toDisplayString(_ctx.t("withmsg")) + " ", 1),
                  _createElementVNode("b", null, "\"" + _toDisplayString(_ctx.t("canundo")) + "\"", 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.t("canundo2")), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_7, [
              _createTextVNode(_toDisplayString(_ctx.t("withmsg2")) + " ", 1),
              _createElementVNode("b", null, "\"" + _toDisplayString(_ctx.t("deletedata")) + "\"", 1),
              _createTextVNode(" " + _toDisplayString(_ctx.t("deletedata2")) + " ", 1),
              _createElementVNode("i", null, _toDisplayString(_ctx.t("attention")), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.t("attention2")), 1)
            ]),
            _createElementVNode("p", null, [
              _createElementVNode("b", null, _toDisplayString(_ctx.t("tempdata")), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.t("tempdata2")), 1)
            ]),
            _createElementVNode("pre", _hoisted_8, _toDisplayString(_ctx.vuexDump), 1),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "button",
                title: _ctx.t('canundo'),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.undo && _ctx.undo(...args))),
                disabled: !_ctx.canUndo
              }, [
                _createElementVNode("span", _hoisted_11, [
                  _createVNode(_component_font_awesome_icon, { icon: "undo" })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t("canundo")), 1)
              ], 8, _hoisted_10),
              _createElementVNode("button", {
                class: "button is-danger",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetLocalData && _ctx.resetLocalData(...args)))
              }, [
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_font_awesome_icon, { icon: "trash-alt" })
                ]),
                _createElementVNode("span", null, _toDisplayString(_ctx.t("deletetempdata")), 1)
              ])
            ])
          ])
        ])
      ]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
}